export enum RequiredTypeEnum {
  NON_REQUIRED = "NON_REQUIRED",
  REQUIRED_BASKET = "REQUIRED_BASKET",
  REQUIRED = "REQUIRED",
}
